import { Provider } from '@angular/core';

import { ContentTranslateUseCasesImpl } from '@app/domain/use-cases/content-translate/content-translate.use-cases';
import { CONTENT_TRANSLATE_USE_CASES } from '@app/domain/use-cases/content-translate/content-translate.use-cases.contract';

export const contentTranslateUseCasesProvider: Provider = {
  provide: CONTENT_TRANSLATE_USE_CASES,
  useClass: ContentTranslateUseCasesImpl
};
